import { Box, Card, CardContent, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { configureAmplify } from "../../helpers/amplifyConfig";
import { signInWithRedirect } from "aws-amplify/auth";
import SSOProvider from "../../types/auth/SSOProvider";
import SSOButton from "../../components/auth/SSOButton/SSOButton";

export function SSOLogin() {
  const { identityProvider } = useParams();
  const { redirect } = useSsoRedirect(identityProvider!);

  useEffect(() => {
    configureAmplify(identityProvider!);
  }, [identityProvider, redirect]);

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Card sx={{ width: 400 }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h5" component="div" gutterBottom>
              Sign in with your provider
            </Typography>
            {identityProvider && (
              <SSOButton onClick={redirect} provider={identityProvider as SSOProvider} />
            )}
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

function useSsoRedirect(provider: SSOProvider | string) {
  const redirect = async () => {
    await signInWithRedirect({
      provider: {
        custom: provider,
      },
    });
  };

  return { redirect };
}
